module.exports = __webpack_public_path__ + "img/ch.a8e12c78.svg";